import { render, staticRenderFns } from "./EventInfos.vue?vue&type=template&id=bf455a16"
import script from "./EventInfos.vue?vue&type=script&lang=js"
export * from "./EventInfos.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports